import { Box, IconButton, Slide, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Colors } from '../config/default';

const SEVERITY_CONFIG = {
  error: { accent: '#ef4444', bg: 'rgba(239, 68, 68, 0.08)' },
  warning: { accent: '#f59e0b', bg: 'rgba(245, 158, 11, 0.08)' },
  info: { accent: '#3b82f6', bg: 'rgba(59, 130, 246, 0.08)' },
  success: { accent: '#22c55e', bg: 'rgba(34, 197, 94, 0.08)' }
};

export default function GlobalBanner({ open, severity = 'error', message, onClose }) {
  if (!open) return null;

  const { accent, bg } = SEVERITY_CONFIG[severity] || SEVERITY_CONFIG.error;

  return (
    <Slide direction="down" in={open} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          left: 16,
          right: 16,
          zIndex: (t) => t.zIndex.appBar + 5
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            px: 3,
            py: 2,
            minHeight: 56,
            borderRadius: 2,
            background: bg,
            backdropFilter: 'blur(10px)',
            border: `1px solid ${accent}33`,
            boxShadow: `0 10px 32px ${accent}22`
          }}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: accent,
              boxShadow: `0 0 0 4px ${accent}33`,
              flexShrink: 0
            }}
          />
          {/* Message */}
          <Typography
            sx={{
              flex: 1,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: 1.6,
              color: Colors.LIGHTGREY
            }}>
            {message}
          </Typography>
          {/* Close */}
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: Colors.LIGHTGREY,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.08)'
              }
            }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Slide>
  );
}
